"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var facepaint_1 = __importDefault(require("facepaint"));
var gridTheme_1 = __importDefault(require("../gridTheme"));
var mq = facepaint_1["default"]([
    "@media(min-width: " + gridTheme_1["default"].breakpoints.sm + "px)",
    "@media(min-width: " + gridTheme_1["default"].breakpoints.md + "px)",
    "@media(min-width: " + gridTheme_1["default"].breakpoints.lg + "px)",
    "@media(min-width: " + gridTheme_1["default"].breakpoints.xl + "px)",
    "@media(min-width: " + gridTheme_1["default"].breakpoints.xxl + "px)",
]);
exports["default"] = mq;
//# sourceMappingURL=mq.js.map